/*
 * Das Berater-Overlay für den Shop — an der Stelle des RevenueHunt-Popups (Entscheidung MS, 27.09.2026).
 * ===========================================================================
 *
 * Läuft NICHT in dieser Anwendung, sondern im Browser des Kunden auf inselvolt.de, als Theme-Datei
 * `assets/iv-berater-overlay.js`, eingebunden in `layout/theme.liquid` vor `</body>`:
 *
 *     <script src="{{ 'iv-berater-overlay.js' | asset_url }}" defer></script>
 *
 * Es liegt hier, weil es sonst nirgends versioniert wäre; der Linter prüft es mit. **Wer hier etwas ändert, ändert
 * die Theme-Datei mit.** Ins Live-Theme nur mit Freigabe von MS.
 *
 * Abgeleitet aus `shop-anfrage-overlay.js` (Auslöser und Ruhezeit unverändert übernommen). Das Formular dort bleibt
 * liegen: Es postet an den Shopify App Proxy `/apps/anfrage`, und der ist im Shop nicht eingerichtet (am 27.09.2026
 * geprüft: 404). Hier gibt es kein Formular — nur den Weg zum Berater. Wer lieber ohne KI fragt, findet die
 * klassische Anfrage auf der Berater-Seite selbst.
 *
 * Wann es erscheint (Auslöser wie `shop-anfrage-overlay.js`, dort begründet):
 *   - auf allen Seiten außer Warenkorb, Kasse und Kundenkonto (MS 27.09.2026 — vorher nur Produktseiten und Blogartikel);
 *   - mit Maus: Zeiger verlässt das Fenster nach oben, frühestens nach 12 Sekunden;
 *   - ohne Maus: zügiges Zurückwischen nach oben, frühestens nach 25 Sekunden; kein Fang des Zurückknopfes;
 *   - einmal, dann 14 Tage Ruhe (`localStorage`); nach einem Klick auf den Berater 90 Tage;
 *   - nie, solange das Cookie-Banner auf eine Entscheidung wartet. Vorschau 27.09.2026: Das Banner lag ÜBER unserem
 *     Fenster — derselbe Fehler, den RevenueHunt am 09.09.2026 hatte. Gefragt wird Shopifys Customer Privacy API
 *     (`currentVisitorConsent()`: leer = noch nicht entschieden); fehlt sie, gilt das Banner als erledigt.
 *
 * Gemessen wird, wie viele Gespräche darüber beginnen: Der Link trägt `?von=shop-exit`, der Berater hält es als Einstieg
 * in seinen Kennzahlen fest (iv Support → Lernen, Wochenbericht). Ein Klick ohne Nachricht ist noch kein Gespräch.
 *
 * Der Berater öffnet im EIGENEN Reiter (Entscheidung MS, 27.09.2026): Der Shop bleibt offen, und die Anmeldung per
 * Mail-Link führt auf konto.inselvolt.de, nicht in ein eingebettetes Fenster. Ein Link, kein `window.open`.
 * Hier steht kein Schlüssel — der Berater ist seit dem 27.09.2026 öffentlich.
 */

(function () {
  'use strict';

  var BERATER = 'https://berater.inselvolt.de/?von=shop-exit';     /* die Kennung zählt der Berater als Einstieg (lernen.js) */
  var FRUEHESTENS_MS = 12000;
  var MOBIL_AB_MS = 25000;
  var RUHE_TAGE = 14;
  var RUHE_NACH_KLICK_TAGE = 90;
  var SPEICHER = 'iv-berater-gesehen';

  /* Text und Gestalt MS 27.09.2026 (Vorlage `exit-intend.html`): aufs Ergebnis statt aufs Zögern, und ohne „Ihre Anlage" —
     wer hier fragt, hat vielleicht noch keine. */
  var TITEL = 'Ihre persönliche Empfehlung – ohne Rätselraten';
  var SCHRITTE = ['Anfrage im Chat beschreiben', 'Berater fragt gezielt nach', 'Fachteam antwortet passgenau'];
  var LOS = 'Empfehlung anfordern';
  var KI = 'Der inselvolt-Berater ist ein KI-Assistent. Er öffnet sich in einem neuen Tab.';

  /* Alle Seiten (MS 27.09.2026) — außer Warenkorb, Kasse und Kundenkonto: Wer bestellt, wird nicht unterbrochen. */
  function passendeSeite() {
    return !/^\/(cart|checkouts?|account)(\/|$)/.test(window.location.pathname);
  }

  /* localStorage kann werfen (privates Fenster, gesperrte Seitendaten) — ein Overlay reißt keine Produktseite mit. */
  function gemerkt() {
    try {
      var wert = window.localStorage.getItem(SPEICHER);
      if (!wert) return false;
      var teile = wert.split(':');
      var tage = teile[0] === 'klick' ? RUHE_NACH_KLICK_TAGE : RUHE_TAGE;
      return (Date.now() - Number(teile[teile.length - 1])) < tage * 86400000;
    } catch (e) {
      return false;
    }
  }

  function merken(wert) {
    try {
      window.localStorage.setItem(SPEICHER, wert);
    } catch (e) {
      /* Kein Fehler, den der Kunde etwas angeht. */
    }
  }

  /* Wartet das Cookie-Banner noch auf eine Entscheidung? Dann kein zweites Fenster darüber — und nichts gemerkt. */
  function bannerOffen() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || !cp.shouldShowBanner || !cp.currentVisitorConsent || !cp.shouldShowBanner()) return false;
      var z = cp.currentVisitorConsent() || {};
      return !z.analytics && !z.marketing && !z.preferences;
    } catch (e) {
      return false;
    }
  }

  var mitMaus = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  var STIL = [
    '.iv-ber-hg{position:fixed;inset:0;background:rgba(15,23,42,.45);-webkit-backdrop-filter:blur(6px);',
    'backdrop-filter:blur(6px);z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px}',
    '.iv-ber{background:#fff;color:#0f172a;max-width:580px;width:100%;border:1px solid #e2e8f0;border-radius:16px;',
    'box-shadow:0 20px 40px rgba(15,23,42,.15);padding:32px 28px 24px;font:400 16px/1.5 ',
    '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;',
    'max-height:92vh;overflow:auto;position:relative;box-sizing:border-box;-webkit-font-smoothing:antialiased}',
    '.iv-ber *{box-sizing:border-box}',
    '.iv-ber h2{margin:0 0 22px;padding-right:32px;font-size:22px;font-weight:700;line-height:1.3;color:#275967}',
    '.iv-ber-schritte{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin:0 0 24px;padding:0;list-style:none}',
    '.iv-ber-schritt{background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:14px 12px;',
    'display:flex;flex-direction:column;gap:8px;margin:0}',
    '.iv-ber-nr{width:24px;height:24px;border-radius:6px;background:#f0f7f9;color:#2A6170;border:1px solid #d0e7ee;',
    'font-size:12px;font-weight:800;display:flex;align-items:center;justify-content:center;flex-shrink:0}',
    '.iv-ber-st{font-size:13px;font-weight:600;line-height:1.35;color:#0f172a}',
    '.iv-ber .iv-ber-los{display:flex;align-items:center;justify-content:center;width:100%;height:50px;',
    'text-decoration:none;background:#e5a93c;color:#121212;border-radius:8px;font-size:15px;font-weight:700;',
    'letter-spacing:.02em;transition:background-color .15s ease}',
    '.iv-ber .iv-ber-los:hover{background:#d4982b}',
    '.iv-ber .iv-ber-los:focus{outline:2px solid #275967;outline-offset:2px}',
    '.iv-ber .iv-ber-nein{display:block;margin:12px auto 20px;background:0;border:0;color:#64748b;',
    'font:inherit;font-size:13.5px;font-weight:500;cursor:pointer;text-decoration:underline;padding:4px}',
    '.iv-ber .iv-ber-nein:hover{color:#275967}',
    '.iv-ber .iv-ber-ki{font-size:12px;line-height:1.4;color:#64748b;text-align:center;margin:0}',
    '.iv-ber .iv-ber-zu{position:absolute;top:20px;right:20px;background:0;border:0;cursor:pointer;color:#64748b;',
    'width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;padding:0;',
    'transition:all .15s ease}',
    '.iv-ber .iv-ber-zu:hover{background:#f8fafc;color:#275967}',
    '.iv-ber .iv-ber-zu svg{width:18px;height:18px;stroke:currentColor;stroke-width:2.2}',
    '@media (max-width:520px){.iv-ber{padding:24px 20px 20px}.iv-ber h2{font-size:19px}',
    '.iv-ber-schritte{grid-template-columns:1fr;gap:8px}',
    '.iv-ber-schritt{flex-direction:row;align-items:center;padding:10px 14px;gap:12px}}',
    '@media (prefers-reduced-motion:no-preference){',
    '.iv-ber{animation:iv-ber-auf .18s ease-out}',
    '@keyframes iv-ber-auf{from{transform:translateY(8px);opacity:0}to{transform:none;opacity:1}}}'
  ].join('');

  var offen = false;

  function zeigen() {
    if (offen || gemerkt() || bannerOffen()) return;
    offen = true;
    merken('gesehen:' + Date.now());

    var stil = document.createElement('style');
    stil.textContent = STIL;
    document.head.appendChild(stil);

    var hg = document.createElement('div');
    hg.className = 'iv-ber-hg';
    hg.setAttribute('role', 'dialog');
    hg.setAttribute('aria-modal', 'true');
    hg.setAttribute('aria-labelledby', 'iv-ber-titel');

    var kasten = document.createElement('div');
    kasten.className = 'iv-ber';

    var zu = document.createElement('button');
    zu.type = 'button';
    zu.className = 'iv-ber-zu';
    zu.setAttribute('aria-label', 'Schließen');
    var SVG = 'http://www.w3.org/2000/svg';
    var kreuz = document.createElementNS(SVG, 'svg');
    kreuz.setAttribute('viewBox', '0 0 24 24');
    kreuz.setAttribute('fill', 'none');
    kreuz.setAttribute('aria-hidden', 'true');
    [[18, 6, 6, 18], [6, 6, 18, 18]].forEach(function (l) {
      var linie = document.createElementNS(SVG, 'line');
      linie.setAttribute('x1', l[0]); linie.setAttribute('y1', l[1]); linie.setAttribute('x2', l[2]); linie.setAttribute('y2', l[3]);
      kreuz.appendChild(linie);
    });
    zu.appendChild(kreuz);

    var titel = document.createElement('h2');
    titel.id = 'iv-ber-titel';
    titel.textContent = TITEL;

    var schritte = document.createElement('ol');
    schritte.className = 'iv-ber-schritte';
    SCHRITTE.forEach(function (satz, i) {
      var li = document.createElement('li');
      li.className = 'iv-ber-schritt';
      var nr = document.createElement('span');
      nr.className = 'iv-ber-nr';
      nr.setAttribute('aria-hidden', 'true');
      nr.textContent = String(i + 1);
      var st = document.createElement('span');
      st.className = 'iv-ber-st';
      st.textContent = satz;
      li.appendChild(nr);
      li.appendChild(st);
      schritte.appendChild(li);
    });

    var los = document.createElement('a');
    los.className = 'iv-ber-los';
    los.href = BERATER;
    los.target = '_blank';
    los.rel = 'noopener';
    los.textContent = LOS;

    var nein = document.createElement('button');
    nein.type = 'button';
    nein.className = 'iv-ber-nein';
    nein.textContent = 'Nein danke, weiter stöbern';

    var ki = document.createElement('p');
    ki.className = 'iv-ber-ki';
    ki.textContent = KI;

    kasten.appendChild(zu);
    kasten.appendChild(titel);
    kasten.appendChild(schritte);
    kasten.appendChild(los);
    kasten.appendChild(nein);
    kasten.appendChild(ki);
    hg.appendChild(kasten);
    document.body.appendChild(hg);

    var vorher = document.activeElement;
    los.focus();

    function schliessen() {
      hg.remove();
      stil.remove();
      document.removeEventListener('keydown', beiTaste);
      offen = false;
      if (vorher && vorher.focus) vorher.focus();
    }

    function beiTaste(e) {
      if (e.key === 'Escape') schliessen();
    }

    document.addEventListener('keydown', beiTaste);
    zu.addEventListener('click', schliessen);
    nein.addEventListener('click', schliessen);
    hg.addEventListener('click', function (e) {
      if (e.target === hg) schliessen();
    });
    /* Der Link öffnet den Reiter selbst; hier wird nur gemerkt und das Fenster im Shop geschlossen. */
    los.addEventListener('click', function () {
      merken('klick:' + Date.now());
      schliessen();
    });
  }

  if (!passendeSeite() || gemerkt()) return;

  var seitStart = Date.now();

  if (mitMaus) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 0) return;
      if (Date.now() - seitStart < FRUEHESTENS_MS) return;
      zeigen();
    });
  } else {
    var letzteHoehe = window.scrollY;
    window.addEventListener('scroll', function () {
      var jetzt = window.scrollY;
      var hoch = letzteHoehe - jetzt;
      letzteHoehe = jetzt;
      if (Date.now() - seitStart < MOBIL_AB_MS) return;
      if (hoch > 90 && jetzt < 220) zeigen();
    }, { passive: true });
  }
}());
